import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { PageLayout } from './components/PageLayout';

const App = () => {    
    return (
        <FluentProvider theme={webLightTheme}>
            <PageLayout />
        </FluentProvider>
    );
};

export default App;